import { useImmer } from "use-immer";
import { useEffect } from "react";
import DayOfWeekCheckboxes from "../DayOfWeekCheckboxes";
import Multiselect from "../Multiselect";

const Component = ({ config, ruleInfoItems, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <article>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Update on days</td>
            <td>
              <DayOfWeekCheckboxes
                dayOfWeekArray={data.updateAtDays}
                onChange={(e) =>
                  updateData((d) => {
                    d.updateAtDays = e;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Update on time [CET]</td>
            <td>
              <input
                type="time"
                value={data.updateAtTime}
                onChange={(e) =>
                  updateData((d) => {
                    d.updateAtTime = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Period count [months]</td>
            <td>
              <input
                type="number"
                value={data.periodCount}
                onChange={(e) =>
                  updateData((d) => {
                    d.periodCount = e.target.value > 0 ? e.target.value : 3;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Minimal delay [days]</td>
            <td>
              <input
                type="number"
                value={data.delayDays}
                onChange={(e) =>
                  updateData((d) => {
                    d.delayDays = e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
    </article>
  );
};

export default Component;
